import {QuizAnswer} from "./QuizAnswer";
import {Answer} from "../../Shared/Model/GameData";

interface QuizAnswersListProps {
    answers: Answer[]
    selected? : number
    onAnswer : (index : number) => void
    children? : JSX.Element
}

export function QuizAnswersList(props: QuizAnswersListProps) {
    return <div className="quiz-answers">
        <ul>{props.answers.map((a, i) =>
            <QuizAnswer
                key={i}
                answer={a}
                selected={props.selected !== undefined && (props.selected === i || a.correct)}
                onClick={() => props.selected === undefined && props.onAnswer(i)}
            />
        )}</ul>
        {props.children}
    </div>
}